module.exports = __webpack_public_path__ + "img/logo.1a9df765.svg";